import Vue from "vue";
import App from "./App.vue";
import store from "./store/index";
import router from "./router/router";
import ElementUI from 'element-ui';
import VueCookies from 'vue-cookies'
import Highcharts from 'highcharts'
import Highcharts_More from 'highcharts/highcharts-more'
import Highcharts_3D from 'highcharts/highcharts-3d'
import HighchartsVue from 'highcharts-vue'
import exportingInit from 'highcharts/modules/exporting'
import exportingData from 'highcharts/modules/export-data'
import highStock from 'highcharts/modules/stock'
import drilldown from 'highcharts/modules/drilldown'
import no_data from 'highcharts/modules/no-data-to-display'
import cylinder from 'highcharts/modules/cylinder'
import './helpers/global.function'
import {
    DataTables,
    DataTablesServer
} from 'vue-data-tables'
import lang from 'element-ui/lib/locale/lang/th'
import lang_th from './lib/custom_lang_datepicker'
import locale from 'element-ui/lib/locale'
import VInputmask from 'v-inputmask';
import Row from 'vue2-admin-lte/src/grid/Row'
import Column from 'vue2-admin-lte/src/grid/Column'
import VModal from 'vue-js-modal'
import VueHtml2Canvas from 'vue-html2canvas';
locale.use(lang_th)
import CKEditor from '@ckeditor/ckeditor5-vue';

Vue.use(CKEditor);
import 'element-ui/lib/theme-chalk/index.css';
import 'expose-loader?$!expose-loader?jQuery!jquery'
import 'bootstrap'
import 'jquery-slimscroll'
import 'jquery-ui/ui/widgets/sortable.js'
import 'jquery-ui/ui/widgets/datepicker.js'
import 'jquery-ui/themes/base/datepicker.css'
import 'admin-lte'
// import 'chart.js'
// import ChartDataLabels from 'chartjs-plugin-datalabels';

import 'chart.piecelabel.js';
// import 'chartjs-plugin-annotation';
// css files
import 'vue2-admin-lte/src/lib/css'
// js files
import 'vue2-admin-lte/src/lib/script'

import DatePicker from './lib/custom_datepicker_th'
import {
    Pagination,
    Dialog,
    Autocomplete,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Input,
    InputNumber,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Switch,
    Select,
    Option,
    OptionGroup,
    Button,
    ButtonGroup,
    Table,
    TableColumn,
    TimeSelect,
    TimePicker,
    Popover,
    Tooltip,
    Breadcrumb,
    BreadcrumbItem,
    Form,
    FormItem,
    Tabs,
    TabPane,
    Tag,
    Tree,
    Alert,
    Slider,
    Icon,
    Upload,
    Progress,
    Spinner,
    Badge,
    Card,
    Rate,
    Steps,
    Step,
    Carousel,
    CarouselItem,
    Collapse,
    CollapseItem,
    Cascader,
    ColorPicker,
    Transfer,
    Container,
    Header,
    Aside,
    Main,
    Footer,
    Timeline,
    TimelineItem,
    Link,
    Divider,
    Image,
    Calendar,
    Backtop,
    PageHeader,
    CascaderPanel,
    Loading,
    MessageBox,
    Message,
    Notification
  } from 'element-ui';
  
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(PageHeader);
Vue.use(CascaderPanel);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

Highcharts_More(Highcharts)
Highcharts_3D(Highcharts)
exportingInit(Highcharts)
exportingData(Highcharts)
no_data(Highcharts)
drilldown(Highcharts)
cylinder(Highcharts)
highStock(Highcharts)

Highcharts.setOptions({
	lang: {
      thousandsSep: ',',
      noData: 'ไม่พบข้อมูล',
      drillUpText: '< Back'
  }
})
Vue.use(HighchartsVue, { highcharts: Highcharts, tagName: 'charts' })
// Vue.use(ElementUI)
Vue.use(DataTables)
Vue.use(DataTablesServer)
Vue.use(VInputmask);
Vue.use(VueCookies)
// Vue.use(ChartDataLabels);
Vue.use(VModal, {
    dynamic: true,
    injectModalsContainer: true,
    dynamicDefaults: { clickToClose: true }
})
Vue.use(VueHtml2Canvas);
Vue.component('row', Row)
Vue.component('column', Column)

var filter = function(text, length, clamp) {
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};


Vue.filter('truncate', filter);
Vue.config.productionTip = false;
new Vue({
    store,
    router,
    render: h => h(App)
}).$mount("#app");